export default __webpack_public_path__ + "static/media/edital-20-2022-1.c504f383.pdf";